import $ from "jquery";
import _ from "lodash";
import { getWidth, onResize } from "../utils/window";
 
export default function hero() {
   const $html = $("html");
   const $scroller = $("html, body");

   const LIST = $('.hero .list');
   const BGS = $('.hero .backgrounds');

   const LIST_ITEMS = LIST.find('.item');
   const BGS_ITEMS = BGS.find('.background');

   var interval, timeout;

   function setIntervalLoop() {
      return setInterval(() => {
         
         let currentListElement = LIST.find(".-active");
         let nextListElement = null;

         let currentBgElement = BGS.find(".-active");
         let nextBgElement = null;

         if (currentListElement.next().length) {
            nextListElement = currentListElement.next();
            nextBgElement = currentBgElement.next();
         } else {
            nextListElement = LIST.find(".item:nth-child(1)");
            nextBgElement = BGS.find(".background:nth-child(1)");
         }

         currentListElement.removeClass("-active");
         nextListElement.addClass("-active");

         currentBgElement.removeClass("-active");
         nextBgElement.addClass("-active");

      }, 5000);
   }

   $(function() {
      if ($(".hero").length) {
         interval = setIntervalLoop();

         LIST.find('.item > a').mouseover(_.debounce(function() {
            const _THIS = $(this).parent();
            const _THIS_BG = $(_THIS.attr('data-id'));

            timeout = window.setTimeout(function() {
               LIST_ITEMS.removeClass('-active');
               BGS_ITEMS.removeClass('-active');
   
               _THIS.addClass('-active');
               _THIS_BG.addClass('-active');
               
               clearInterval(interval);
               interval = false;
            }, 1000);

         }, 50));

         LIST.find('.item > a').mouseout(_.debounce(function() {
            
            clearTimeout(timeout);
            
            if(!interval) {
               interval = setIntervalLoop();
            }

         }, 50));
      }
   });
}



// WEBPACK FOOTER //
// ./source/scripts/sections/hero.js